import { PennDotDistricts } from "../calculations/safety/SPFConstants.ts";

export const COUNTIES = {
  ADAMS: "ADAMS",
  ALLEGHENY: "ALLEGHENY",
  ARMSTRONG: "ARMSTRONG",
  BEAVER: "BEAVER",
  BEDFORD: "BEDFORD",
  BERKS: "BERKS",
  BLAIR: "BLAIR",
  BRADFORD: "BRADFORD",
  BUCKS: "BUCKS",
  BUTLER: "BUTLER",
  CAMBRIA: "CAMBRIA",
  CAMERON: "CAMERON",
  CARBON: "CARBON",
  CENTRE: "CENTRE",
  CHESTER: "CHESTER",
  CLARION: "CLARION",
  CLEARFIELD: "CLEARFIELD",
  CLINTON: "CLINTON",
  COLUMBIA: "COLUMBIA",
  CRAWFORD: "CRAWFORD",
  CUMBERLAND: "CUMBERLAND",
  DAUPHIN: "DAUPHIN",
  DELAWARE: "DELAWARE",
  ELK: "ELK",
  ERIE: "ERIE",
  FAYETTE: "FAYETTE",
  FOREST: "FOREST",
  FRANKLIN: "FRANKLIN",
  FULTON: "FULTON",
  GREENE: "GREENE",
  HUNTINGDON: "HUNTINGDON",
  INDIANA: "INDIANA",
  JEFFERSON: "JEFFERSON",
  JUNIATA: "JUNIATA",
  LACKAWANNA: "LACKAWANNA",
  LANCASTER: "LANCASTER",
  LAWRENCE: "LAWRENCE",
  LEBANON: "LEBANON",
  LEHIGH: "LEHIGH",
  LUZERNE: "LUZERNE",
  LYCOMING: "LYCOMING",
  MCKEAN: "MCKEAN",
  MERCER: "MERCER",
  MIFFLIN: "MIFFLIN",
  MONROE: "MONROE",
  MONTGOMERY: "MONTGOMERY",
  MONTOUR: "MONTOUR",
  NORTHAMPTON: "NORTHAMPTON",
  NORTHUMBERLAND: "NORTHUMBERLAND",
  PERRY: "PERRY",
  PHILADELPHIA: "PHILADELPHIA",
  PIKE: "PIKE",
  POTTER: "POTTER",
  SCHUYLKILL: "SCHUYLKILL",
  SNYDER: "SNYDER",
  SOMERSET: "SOMERSET",
  SULLIVAN: "SULLIVAN",
  SUSQUEHANNA: "SUSQUEHANNA",
  TIOGA: "TIOGA",
  UNION: "UNION",
  VENANGO: "VENANGO",
  WARREN: "WARREN",
  WASHINGTON: "WASHINGTON",
  WAYNE: "WAYNE",
  WESTMORELAND: "WESTMORELAND",
  WYOMING: "WYOMING",
  YORK: "YORK",
};

export const COUNTY_LABELS = {
  [COUNTIES.ADAMS]: "Adams",
  [COUNTIES.ALLEGHENY]: "Allegheny",
  [COUNTIES.ARMSTRONG]: "Armstrong",
  [COUNTIES.BEAVER]: "Beaver",
  [COUNTIES.BEDFORD]: "Bedford",
  [COUNTIES.BERKS]: "Berks",
  [COUNTIES.BLAIR]: "Blair",
  [COUNTIES.BRADFORD]: "Bradford",
  [COUNTIES.BUCKS]: "Bucks",
  [COUNTIES.BUTLER]: "Butler",
  [COUNTIES.CAMBRIA]: "Cambria",
  [COUNTIES.CAMERON]: "Cameron",
  [COUNTIES.CARBON]: "Carbon",
  [COUNTIES.CENTRE]: "Centre",
  [COUNTIES.CHESTER]: "Chester",
  [COUNTIES.CLARION]: "Clarion",
  [COUNTIES.CLEARFIELD]: "Clearfield",
  [COUNTIES.CLINTON]: "Clinton",
  [COUNTIES.COLUMBIA]: "Columbia",
  [COUNTIES.CRAWFORD]: "Crawford",
  [COUNTIES.CUMBERLAND]: "Cumberland",
  [COUNTIES.DAUPHIN]: "Dauphin",
  [COUNTIES.DELAWARE]: "Delaware",
  [COUNTIES.ELK]: "Elk",
  [COUNTIES.ERIE]: "Erie",
  [COUNTIES.FAYETTE]: "Fayette",
  [COUNTIES.FOREST]: "Forest",
  [COUNTIES.FRANKLIN]: "Franklin",
  [COUNTIES.FULTON]: "Fulton",
  [COUNTIES.GREENE]: "Greene",
  [COUNTIES.HUNTINGDON]: "Huntingdon",
  [COUNTIES.INDIANA]: "Indiana",
  [COUNTIES.JEFFERSON]: "Jefferson",
  [COUNTIES.JUNIATA]: "Juniata",
  [COUNTIES.LACKAWANNA]: "Lackawanna",
  [COUNTIES.LANCASTER]: "Lancaster",
  [COUNTIES.LAWRENCE]: "Lawrence",
  [COUNTIES.LEBANON]: "Lebanon",
  [COUNTIES.LEHIGH]: "Lehigh",
  [COUNTIES.LUZERNE]: "Luzerne",
  [COUNTIES.LYCOMING]: "Lycoming",
  [COUNTIES.MCKEAN]: "Mckean",
  [COUNTIES.MERCER]: "Mercer",
  [COUNTIES.MIFFLIN]: "Mifflin",
  [COUNTIES.MONROE]: "Monroe",
  [COUNTIES.MONTGOMERY]: "Montgomery",
  [COUNTIES.MONTOUR]: "Montour",
  [COUNTIES.NORTHAMPTON]: "Northampton",
  [COUNTIES.NORTHUMBERLAND]: "Northumberland",
  [COUNTIES.PERRY]: "Perry",
  [COUNTIES.PHILADELPHIA]: "Philadelphia",
  [COUNTIES.PIKE]: "Pike",
  [COUNTIES.POTTER]: "Potter",
  [COUNTIES.SCHUYLKILL]: "Schuylkill",
  [COUNTIES.SNYDER]: "Snyder",
  [COUNTIES.SOMERSET]: "Somerset",
  [COUNTIES.SULLIVAN]: "Sullivan",
  [COUNTIES.SUSQUEHANNA]: "Susquehanna",
  [COUNTIES.TIOGA]: "Tioga",
  [COUNTIES.UNION]: "Union",
  [COUNTIES.VENANGO]: "Venango",
  [COUNTIES.WARREN]: "Warren",
  [COUNTIES.WASHINGTON]: "Washington",
  [COUNTIES.WAYNE]: "Wayne",
  [COUNTIES.WESTMORELAND]: "Westmoreland",
  [COUNTIES.WYOMING]: "Wyoming",
  [COUNTIES.YORK]: "York",
};

export const getDistrictForCounty = (county) => {
  switch (county) {
    case COUNTIES.CRAWFORD:
    case COUNTIES.ERIE:
    case COUNTIES.FOREST:
    case COUNTIES.MERCER:
    case COUNTIES.VENANGO:
    case COUNTIES.WARREN:
      return PennDotDistricts.DISTRICT_1;
    case COUNTIES.CAMERON:
    case COUNTIES.CENTRE:
    case COUNTIES.CLEARFIELD:
    case COUNTIES.CLINTON:
    case COUNTIES.ELK:
    case COUNTIES.JUNIATA:
    case COUNTIES.MCKEAN:
    case COUNTIES.MIFFLIN:
    case COUNTIES.POTTER:
      return PennDotDistricts.DISTRICT_2;
    case COUNTIES.BRADFORD:
    case COUNTIES.COLUMBIA:
    case COUNTIES.LYCOMING:
    case COUNTIES.MONTOUR:
    case COUNTIES.NORTHUMBERLAND:
    case COUNTIES.SNYDER:
    case COUNTIES.SULLIVAN:
    case COUNTIES.TIOGA:
    case COUNTIES.UNION:
      return PennDotDistricts.DISTRICT_3;
    case COUNTIES.LACKAWANNA:
    case COUNTIES.LUZERNE:
    case COUNTIES.PIKE:
    case COUNTIES.SUSQUEHANNA:
    case COUNTIES.WAYNE:
    case COUNTIES.WYOMING:
      return PennDotDistricts.DISTRICT_4;
    case COUNTIES.BERKS:
    case COUNTIES.CARBON:
    case COUNTIES.LEHIGH:
    case COUNTIES.MONROE:
    case COUNTIES.NORTHAMPTON:
    case COUNTIES.SCHUYLKILL:
      return PennDotDistricts.DISTRICT_5;
    case COUNTIES.BUCKS:
    case COUNTIES.CHESTER:
    case COUNTIES.DELAWARE:
    case COUNTIES.MONTGOMERY:
    case COUNTIES.PHILADELPHIA:
      return PennDotDistricts.DISTRICT_6;
    case COUNTIES.ADAMS:
    case COUNTIES.CUMBERLAND:
    case COUNTIES.DAUPHIN:
    case COUNTIES.FRANKLIN:
    case COUNTIES.LANCASTER:
    case COUNTIES.LEBANON:
    case COUNTIES.PERRY:
    case COUNTIES.YORK:
      return PennDotDistricts.DISTRICT_8;
    case COUNTIES.BEDFORD:
    case COUNTIES.BLAIR:
    case COUNTIES.CAMBRIA:
    case COUNTIES.FULTON:
    case COUNTIES.HUNTINGDON:
    case COUNTIES.SOMERSET:
      return PennDotDistricts.DISTRICT_9;
    case COUNTIES.ARMSTRONG:
    case COUNTIES.BUTLER:
    case COUNTIES.CLARION:
    case COUNTIES.INDIANA:
    case COUNTIES.JEFFERSON:
      return PennDotDistricts.DISTRICT_10;
    case COUNTIES.ALLEGHENY:
    case COUNTIES.BEAVER:
    case COUNTIES.LAWRENCE:
      return PennDotDistricts.DISTRICT_11;
    case COUNTIES.FAYETTE:
    case COUNTIES.GREENE:
    case COUNTIES.WASHINGTON:
    case COUNTIES.WESTMORELAND:
      return PennDotDistricts.DISTRICT_12;
    default:
      throw new Error("County does not map to penn dot district");
  }
};

export const AREA_TYPES = {
  URBAN: "URBAN",
  RURAL: "RURAL",
  SUBURBAN: "SUBURBAN",
};
